import axiosLogin from "global/helpers/axiosLogin";
import axiosInstance from "../../../../global/helpers/axiosInstance";
import {
  ENVIARMAIL_ERROR,
  ENVIARMAIL_LOADING,
  ENVIARMAIL_RESET,
  ENVIARMAIL_SUCCESS,
} from "../../ActionTypes";
import { parseBackendError, logError } from "../../../../global/utils/errorHandler";

/* export const wsPostEnviarMailInforme =
  (informeDto, idPacienteFamiliar) => (dispatch) => {
    dispatch({
      type: ENVIARMAIL_LOADING,
    });
    axiosInstance().then((respuesta) => {
      respuesta
        .post(`/informes/mail/${idPacienteFamiliar}`, informeDto)
        .then((res) => {
          dispatch({
            type: ENVIARMAIL_SUCCESS,
            payload: res.status,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: ENVIARMAIL_ERROR,
            payload: error,
          });
        });
    });
  }; */
export const wsPostEnviarMailInforme =
  (informeDto, idPacienteFamiliar) => (dispatch) => {
    dispatch({
      type: ENVIARMAIL_LOADING,
    });
    axiosLogin().then((respuesta) => {
      respuesta
        .post(`dis/informes/mail`, informeDto)
        .then((res) => {
          dispatch({
            type: ENVIARMAIL_SUCCESS,
            payload: res.status,
          });
        })
        .catch((err) => {
          const parsedError = parseBackendError(err);
          logError(err, "Enviar mail informe");

          let error = {
            detail: parsedError.userMessage,
            type: parsedError.type,
            validationErrors: parsedError.validationErrors,
            technicalDetails: parsedError.technicalDetails,
            title: parsedError.title,
            rawData: parsedError.rawData,
          };

          dispatch({
            type: ENVIARMAIL_ERROR,
            payload: error,
          });
        });
    });
  };
export const wsPostEnviarMailLaboratorio =
  (mailLaboratorioDto, idPacienteFamiliar) => (dispatch) => {
    dispatch({
      type: ENVIARMAIL_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .post(`lis/laboratorio/mail`, {
          email: mailLaboratorioDto.email,
          idProtocolo: mailLaboratorioDto.idProtocolo,
          idPacFamiliar: idPacienteFamiliar !== "" ? idPacienteFamiliar : -1,
        })
        .then((res) => {
          dispatch({
            type: ENVIARMAIL_SUCCESS,
            payload: res.status,
          });
        })
        .catch((err) => {
          const parsedError = parseBackendError(err);
          logError(err, "Enviar mail laboratorio");

          let error = {
            detail: parsedError.userMessage,
            type: parsedError.type,
            validationErrors: parsedError.validationErrors,
            technicalDetails: parsedError.technicalDetails,
            title: parsedError.title,
            rawData: parsedError.rawData,
          };

          dispatch({
            type: ENVIARMAIL_ERROR,
            payload: error,
          });
        });
    });
  };
/* export const wsPostEnviarMailLaboratorio =
  (mailLaboratorioDto, idPacienteFamiliar) => (dispatch) => {
    dispatch({
      type: ENVIARMAIL_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .post(`/laboratorio/pdf/${idPacienteFamiliar}`, {
          email: mailLaboratorioDto.email,
          idProtocolo: mailLaboratorioDto.idProtocolo,
        })
        .then((res) => {
          dispatch({
            type: ENVIARMAIL_SUCCESS,
            payload: res.status,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: ENVIARMAIL_ERROR,
            payload: error,
          });
        });
    });
  }; */

export const resetEnviarMail = () => (dispatch) => {
  dispatch({
    type: ENVIARMAIL_RESET,
  });
};
